import React from "react"

import { AppCardTitle, AppDataTable } from "@components"
import { categoryColumn, dateColumn } from "./columns"
import BITableActions from "./Actions"


export default function BITable({ dataTable, columnValues, filters, options, ...props }) {
	return <AppDataTable
		title={<AppCardTitle icon="table-cells" title="Price Comparison"/>}
		toolbarProps={{ filters: filters }}
		data={dataTable}
		columns={[
			...categoryColumn(filters?.reportType),
			...columnValues?.length ? columnValues?.map((date, idx) => dateColumn(date, idx)) : []
		]}
		options={{
			customToolbar: () => <BITableActions/>,
			...options,
		}}
		{...props}
	/>
}